export default '0.0.0-semantically-released';
